
import React, { Suspense} from "react";
import { toast } from 'sonner';
import {  useSelector } from "react-redux";


import RaydiumLeftSideBar from "./components/RaydiumLeftSideBar/RaydiumLeftSideBar";
import RaydiumCharts from "./components/RaydiumCharts/RaydiumCharts";

import { selectedChart, openedCharts, displayNewChart, removeSelectedChart } from "../../lib/chartSlice";
import RayBotInputs from "./components/RayBotInputs/RayBotInputs";
import TokenTrades from "./components/TokenTrades/TokenTrades";
import RaydiumRightSideBar from "./components/RaydiumRightSideBar/RaydiumRightSideBar";
import RaydiumRobot from "./components/RaydiumRobot/RaydiumRobot";

const RaydiumMain = React.lazy(() => import('./components/RaydiumMain/RaydiumMain'))



export default function Raydium() {

  const displayedChart = useSelector(selectedChart)
  const charts = useSelector(openedCharts)

  const showToast = (title, description, params) => {
    toast(title, {
      className: ` opacity-95 shadow text-neutral-200 border-neutral-700 ${params?.type == "buy" ? "bg-green-800" : "bg-neutral-900"} `,
      description: description,
      duration: params?.duration || 5000,
      position: params?.position || 'top-left',
      dismissible: true,
    });
  }


  return (
    <div className="container min-h-[100vh] relative pt-5">


    <Suspense fallback='wait' >
                    
                      <RaydiumRobot icon='FaRobot' name='Rayfast Robot' charts={charts} displayedChart={displayedChart} />
{/* 
                    <RaydiumMain  >
                    <RaydiumRobot icon='FaRobot' name='Rayfast Robot' charts={charts} displayedChart={displayedChart} />
                    <RayBotInputs icon='FaRobot' name='PhoenixBot' charts={charts} displayedChart={displayedChart} />
                    <RaydiumCharts icon='LuChartCandlestick' name='Chart' charts={charts} displayedChart={displayedChart} />
                    <TokenTrades icon='FaChartBar' name='token trades' chart={displayedChart} />
                    </RaydiumMain > */}
                  </Suspense >
                    </div>
  )

//   return (
//     <div className="w-full h-full relative">
//       {/* <div className="w-full h-max bg-neutral-950 shadow-lg shadow-black border-b border-neutral-900 sticky top-0 z-[20]">
//         <div className="container">
//           <div className="flex gap-5 items-center w-full justify-center h-12">
//             <p className="text-md font-semiBold">How to use</p>
//             <p className="text-md font-semiBold">Subscribe</p>
//             <p className="text-md font-semiBold">Support</p>
//           </div>
//         </div>
//       </div> */}
//       <div className=" mx-auto  min-h-screen h-max   grid grid-cols-[auto,1fr] ">
//         <RaydiumLeftSideBar displayedChart={displayedChart} />
//         <div>
//           {
//             <div className="grid grid-cols-1 p-0 ">
//               <div className="grid grid-cols-[1fr,auto] h-full w-full p-0 m-0 ">
//                 <div className="flex flex-col !w-[100%] min-h-screen relative ">
//                   {/* <ChartTabs /> */}
//                   <Suspense fallback='wait' >
                    
//                       <RaydiumRobot icon='FaRobot' name='Rayfast Robot' charts={charts} displayedChart={displayedChart} />
// {/* 
//                     <RaydiumMain  >
//                       <RaydiumRobot icon='FaRobot' name='Rayfast Robot' charts={charts} displayedChart={displayedChart} />
//                       <RayBotInputs icon='FaRobot' name='PhoenixBot' charts={charts} displayedChart={displayedChart} />
//                       <RaydiumCharts icon='LuChartCandlestick' name='Chart' charts={charts} displayedChart={displayedChart} />
//                       <TokenTrades icon='FaChartBar' name='token trades' chart={displayedChart} />
//                     </RaydiumMain > */}
//                   </Suspense >
//                   {/* <Suspense fallback='wait' >
//                     <RaydiumDataView />
//                   </Suspense > */}
//                 </div>
//                 <RaydiumRightSideBar displayedChart={displayedChart} />
//               </div>
//             </div>
//           }
//         </div>
//       </div>
//       {/* 
//       <div className="h-10 w-[100%] bg-neutral-900 border-t border-neutral-800 sticky bottom-0">
//         <RaydiumBotInputs />
//       </div> */}
//     </div>
//   );
}



